import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseOptions';
import './HeroCarousel.css';

export default function HeroCarousel() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'albums'));
        let allImages = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.images && data.images.length > 0) {
            allImages = [...allImages, ...data.images];
          }
        });

        // Shuffle images
        allImages = allImages.sort(() => 0.5 - Math.random());
        // Take top 10-15
        setImages(allImages.slice(0, 15));
      } catch (error) {
        console.error('Error fetching carousel images', error);
      }
    };

    fetchImages();
  }, []);

  if (images.length === 0) return null;

  return (
    <div className="hero-carousel">
      <div className="carousel-track">
        {images.map((img, index) => (
          <div key={index} className="carousel-item">
            {img.includes('.mp4') || img.includes('.webm') ? (
              <video src={img} muted loop autoPlay playsInline />
            ) : (
              <img src={img} alt="portfolio highlight" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
